import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { ZendeskService } from '../../service';

export type ListDeletionSchedulesConfig = typeof ListDeletionSchedulesConfig._.Config;

export const ListDeletionSchedulesConfig = IntegrationConfig.make({
  service: ZendeskService,
  name: Integration_Handler_Names_Enum.ListDeletionSchedules,
  configSchema: z.object({}),
});
